import type { DocumentTaskFromResponse } from 'shared/features/workflow/workflow.types';

export const getDocumentTitle = (documentTask: DocumentTaskFromResponse) => {
  return documentTask?.properties?.document?.title ?? '';
};
